import { render, staticRenderFns } from "./ord_pack.vue?vue&type=template&id=1397310f&scoped=true"
import script from "./ord_pack.vue?vue&type=script&lang=js"
export * from "./ord_pack.vue?vue&type=script&lang=js"
import style0 from "./ord_pack.vue?vue&type=style&index=0&id=1397310f&prod&scoped=true&lang=less"
import style1 from "./ord_pack.vue?vue&type=style&index=1&id=1397310f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1397310f",
  null
  
)

export default component.exports